import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiService } from "../../services/axios";

export const fetchStudentDashboardData = createAsyncThunk(
  "studentDashboard/fetchData",
  async (courseIds, { rejectWithValue }) => {
    try {
      const ids = Array.isArray(courseIds) ? courseIds : courseIds ? [courseIds] : [];
      const params = new URLSearchParams();
      ids.forEach((id) => params.append("courseId", id));
      const query = params.toString();
      const url = query
        ? `/dashboard/get-exam-history?${query}`
        : "/dashboard/get-exam-history";
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const studentDashboardSlice = createSlice({
  name: "studentDashboard",
  initialState: {
    loading: false,
    examHistoryLoading: false,
    error: null,
    // Tracks the most recently dispatched request, so a slower/older
    // request (e.g. for a course the user already switched away from)
    // can't overwrite a newer one that resolved first.
    currentRequestId: undefined,
    stats: {
      finishedExam: 0,
      latestExam: 0,
      totalQuestionCategories: 0,
      totalQuestions: 0,
    },
    exam_history: [],
    questionPapers: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStudentDashboardData.pending, (state, action) => {
        state.loading = true;
        state.examHistoryLoading = true;
        state.error = null;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(fetchStudentDashboardData.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.currentRequestId) return;
        state.loading = false;
        state.examHistoryLoading = false;
        state.stats = {
          finishedExam: action.payload.finishedExam,
          latestExam: action.payload.allQuestionPaper,
          totalQuestionCategories: action.payload.totalCategory,
          totalQuestions: action.payload.allQuestion,
        };
        state.exam_history = action.payload.data.exam_history || [];
        state.questionPapers = action.payload.data.question_paper?.filter((item)=>item?.isActive) || [];
      })
      .addCase(fetchStudentDashboardData.rejected, (state, action) => {
        if (action.meta.requestId !== state.currentRequestId) return;
        state.loading = false;
        state.examHistoryLoading = false;
        state.error = action.payload || "Failed to fetch dashboard data";
      });
  },
});

export default studentDashboardSlice.reducer;